import React, { useMemo } from 'react';
import { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import IUniteServiceType from '../../models/IUniteServiceType';
import GestionAbstract from '../../components/forms/gestion-abstract';
import useEnum from '../../hooks/useEnum';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionTypesServicesProps {
  isModeSelection?: boolean;
}

class UniteServiceType extends IBaseModel implements IUniteServiceType {
  idUniteServiceType: Guid = Guid.empty;
  serviceType: number = 0;
  typeAmperage: number = 0;
}

export default function GestionTypesServices({ isModeSelection }: IGestionTypesServicesProps) {
  const { editorOptions: typesDeServicesEditorOptions } = useEnum(undefined, "gestionTypesServices");
  const { editorOptions: typeAmperagesEditorOptions } = useEnum(undefined, "gestionTypesAmperages", "7rem");
  const ELECTRICITE_TYPE_SERVICE_ID = 4;

  const descriptionEditorOptions = useMemo(() => {
    return { maxLength: 200, width: 200 }
  }, []);

  return (
    <GestionAbstract<IUniteServiceType>
      isModeSelection={isModeSelection}
      path="UniteServiceType"
      model={UniteServiceType}
      customFormItems={(selectedService) => (
        <GroupItem caption={"Type de service"}>
          <SimpleItem key={"frm-description"} dataField={"description"} editorOptions={descriptionEditorOptions}>
            <Label text={"Description"} showColon={false} />
          </SimpleItem>
          <SimpleItem key={"frm-type-service"} dataField={"serviceType"} editorType={"dxRadioGroup"} editorOptions={typesDeServicesEditorOptions}>
            <Label visible={false} />
          </SimpleItem>
          {selectedService?.serviceType === ELECTRICITE_TYPE_SERVICE_ID &&
            <SimpleItem key={"frm-type-amperage"} dataField={"typeAmperage"} editorType={"dxSelectBox"} editorOptions={typeAmperagesEditorOptions}>
              <Label text="Ampérage" />
            </SimpleItem>
          }
        </GroupItem>
      )}
    />
  );
}